import { FC, ReactNode } from 'react';
import { NumberUtils, Tr } from '@utils';
import { Divider, Stack, Typography } from '@mui/material';
import { IVoltaageModalDialogProps, VoltaageModalDialog } from '@components/common';
import { ReactComponent as Illustration } from '@assets/illustrations/generating-result.svg';

export interface IGeneratingResultsDialogProps extends IVoltaageModalDialogProps {
	contentTitle?: ReactNode;
}

export const GeneratingResultsDialog: FC<IGeneratingResultsDialogProps> = ({ contentTitle, ...props }) => {
	return (
		<VoltaageModalDialog
			title={<Tr.Portal path="generating-result-dialog.title" />}
			disablePortal
			sx={{ '&.MuiDialog-root': { position: 'absolute', margin: 0 } }}
			BackdropProps={{ sx: { '&.MuiBackdrop-root': { position: 'absolute', backdropFilter: 'blur(8px)' } } }}
			{...props}
		>
			<Divider light />
			<Stack direction="row" sx={{ paddingX: 10, paddingY: 6 }} spacing={6}>
				<Illustration style={{ minWidth: 188 }} />
				<Stack direction="column" spacing={3}>
					{contentTitle && <Typography sx={{ fontWeight: 'bold' }}>{contentTitle}</Typography>}
					<Divider light />
					<Typography>
						<Tr.Portal path={`generating-result-dialog.footer.${NumberUtils.random(1, 3)}`} />
					</Typography>
				</Stack>
			</Stack>
		</VoltaageModalDialog>
	);
};
